'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBarActions", {
    enumerable: true,
    get: function() {
        return MessageBarActions;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMessageBarActions = require("./useMessageBarActions");
const _renderMessageBarActions = require("./renderMessageBarActions");
const _useMessageBarActionsStylesstyles = require("./useMessageBarActionsStyles.styles");
const _useMessageBarActionsContextValues = require("./useMessageBarActionsContextValues");
const MessageBarActions = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMessageBarActions.useMessageBarActions_unstable)(props, ref);
    (0, _useMessageBarActionsStylesstyles.useMessageBarActionsStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMessageBarActionsStyles_unstable')(state);
    return (0, _renderMessageBarActions.renderMessageBarActions_unstable)(state, (0, _useMessageBarActionsContextValues.useMessageBarActionsContextValue_unstable)());
});
MessageBarActions.displayName = 'MessageBarActions';
